import styled from 'styled-components'

import { colors } from 'shared/styles/colors'

export const Input = styled.input`
  height: 7.2vh;
  max-height: 68px;
  min-width: 53px;
  max-width: 53px;
  padding: 8px;
  border: 1px solid ${colors.grayLight};
  border-radius: 8px;
  text-align: center;
  font-size: 2.125rem;
`
